'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const DEFAULT_TTL = 60;
class InMemoryApiCacheService {
  constructor() {
    this.cacheStore = new Map();
  }
  static getInstance() {
    if (!InMemoryApiCacheService.instance) {
      InMemoryApiCacheService.instance = new InMemoryApiCacheService();
    }
    return InMemoryApiCacheService.instance;
  }
  get(key) {
    if (!this.cacheStore.has(key)) {
      return null;
    }
    const cachedResponse = this.cacheStore.get(key);
    if (cachedResponse === void 0) {
      return null;
    }
    if (cachedResponse.expirationTimestamp < Date.now()) {
      this.cacheStore.delete(key);
      return null;
    }
    return cachedResponse.response;
  }
  set(key, response, ttl) {
    const secondsTimeout = isNaN(ttl) ? DEFAULT_TTL : ttl;
    const expirationTimestamp = Date.now() + secondsTimeout * 1e3;
    this.cacheStore.set(key, { response, expirationTimestamp });
    return expirationTimestamp;
  }
  deleteCached(key) {
    this.cacheStore.delete(key);
  }
  purge() {
    const now = Date.now();
    const removed = [];
    this.cacheStore.forEach((response, key) => {
      if (response.expirationTimestamp < now) {
        this.cacheStore.delete(key);
        removed.push(key);
      }
    });
    return removed;
  }
}

exports.InMemoryApiCacheService = InMemoryApiCacheService;
